module.exports = __webpack_public_path__ + "static/img/banner1.0561f1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/smartsite/banner1.png
// module id = 2khm
// module chunks = 12